import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SmallOrdersComponent } from './small-orders.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: SmallOrdersComponent,
      },
      {
        path: 'create',
        loadChildren: () => import('./create-small-order/create-small-order.module').then(mod => mod.CreateSmallOrderModule),
      },
      {
        path: ':id',
        loadChildren: () => import('./create-small-order/create-small-order.module').then(mod => mod.CreateSmallOrderModule),
      },
      {
        path: ':id/details',
        loadChildren: () => import('./small-order-details/small-order-details.module').then(mod => mod.SmallOrderDetailsModule),
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SmallOrdersRoutingModule { }
